import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import ru from './ru.json';

/**
 * Detection order:
 *   1. localStorage (user explicitly toggled before)
 *   2. Telegram user's language_code (if running inside Telegram)
 *   3. Browser navigator.language
 *   4. 'en' fallback
 *
 * IMPORTANT: we don't pass `lng` explicitly here — that would shadow
 * detection. The LanguageDetector handles localStorage and navigator;
 * Telegram language is injected as `htmlTag` fallback below.
 */

// Read Telegram language first so the detector can use it as 1st-launch hint.
// We can't put it inside detection chain (LanguageDetector only knows about
// a fixed set of sources), so we set `htmlTag` lang attribute and tell the
// detector to read it.
(() => {
  const tg = (window as any).Telegram?.WebApp;
  const code = tg?.initDataUnsafe?.user?.language_code;
  if (code && document?.documentElement) {
    document.documentElement.lang = code.startsWith('ru') ? 'ru' : 'en';
  }
})();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
    },
    // No `lng` here on purpose — LanguageDetector decides.
    supportedLngs: ['en', 'ru'],
    nonExplicitSupportedLngs: true,   // 'ru-RU' counts as 'ru'
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      // Look-up priority. localStorage wins so user's explicit choice persists.
      order: ['localStorage', 'htmlTag', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18n;
